// test1994
(1994 && 0);
